module.exports = __webpack_public_path__ + "img/6.cec37d15.jpg";